import { FalhaServico } from '../falha-servico';

export class AcoesJudiciais{
    falhaServico: FalhaServico;
    resultados: Array<AcaoJudicial>;

    constructor(){
        this.falhaServico = new FalhaServico()
        this.resultados = [];
    }

}

export class AcaoJudicial{
    processo: string;
    valor: string;
    dataOcorrencia: string;
    vara: string;
    cidade: string;
    uf: string;
    natureza: string;
}
